import { FC } from 'react';

import PageContainer from '../PageContainer/PageContainer';
import LeftPanel from '../LeftPanel/LeftPanel';

import css from './MainPageWrapper.module.css';

interface IMainPaneWrapperProps {
  children: JSX.Element[] | JSX.Element;
  hideLeftPanel?: boolean;
}

const PageWrapper: FC<IMainPaneWrapperProps> = ({ children, hideLeftPanel }) => {
  return (
    <PageContainer>
      <div className={css.Container}>
        {!hideLeftPanel && <LeftPanel />}
        <div
          className={`${css.ContentWrapper} ${
            hideLeftPanel ? css.ContentWrapperNoPanel : ''
          }`}
        >
          {children}
        </div>
      </div>
    </PageContainer>
  );
};

export default PageWrapper;
